module.exports = "https://cdn2-fs.clearscore.com/flux/images/03935758591f48ff186e99f05ebe3d74.png";